import { Api, Auth } from '~/services'


export function requestVerificationLink() {
	return ( dispatch, getStore ) => {

		if( !Auth.loggedIn() ) return

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_EMAIL_VERIFICATION_LINK'
				})

				Api.get( '/wp/user/email/verify', {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_VISIBLE_NOTIFICATION',
						notification: data
					})
				})

			}
		)

	}
}


export function verifyEmailAddress( key ) {
	return ( dispatch, getStore ) => {

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_EMAIL_VERIFICATION'
				})

				Api.post( '/wp/user/email/verify/' + key, {}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					if( !!data ) {
						dispatch({
							type: 'RECEIVE_VISIBLE_NOTIFICATION',
							notification: data
						})
					}
					dispatch({
						type: 'RECEIVE_EMAIL_VERIFICATION',
						verified: !!data
					})
				})

			}
		)

	}
}



// WEBPACK FOOTER //
// ./src/js/actions/verification.js